import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_PDF_create extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_pdf_create">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.PDF.create</h2>
              <p>
                NL.PDF.create allows you to create a PDF from either a URL or
                HTML string from the Application and Workflow events.
              </p>
              <WorkflowCompatibility front={true} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">url</td>
                    <td>
                      Website URL to use as PDF source.
                      <br />
                      <i>String example https://www.nexoid.com</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">html</td>
                    <td>
                      HTML string to use as PDF source.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">filename</td>
                    <td>
                      File name of output PDF.
                      <br />
                      <i>String example "output.pdf"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">link_expire</td>
                    <td>
                      File expiry in minutes.
                      <br />
                      <i>int</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.PDF.create Example</h2>
              <p>This example create a PDF from URL.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">url</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">https://www.nexoid.com</span>
                  <span className="jsonA">"</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">PDF</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">create</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>
                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_PDF_create;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_PDF_create.js